
(function(){
  "use strict";
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isTouch = window.matchMedia && window.matchMedia('(hover:none),(pointer:coarse)').matches;
  var hasGSAP = typeof window.gsap !== 'undefined';
  var hasST = hasGSAP && typeof window.ScrollTrigger !== 'undefined';
  var rand = function(a,b){ return a + Math.random()*(b-a); };
  var lattice = null;

  function showAll(){
    document.querySelectorAll('.reveal').forEach(function(e){ e.style.opacity=1; e.style.transform='none'; });
  }
  function killPreloader(){
    var pl = document.getElementById('preloader');
    document.body.classList.remove('loading');
    if(!pl) return;
    pl.style.transition='opacity .5s ease';
    pl.style.opacity='0';
    pl.style.pointerEvents='none';
    setTimeout(function(){ if(pl && pl.parentNode) pl.parentNode.removeChild(pl); }, 620);
  }
  var safety = setTimeout(function(){ killPreloader(); showAll(); }, 4000);

  function toastMsg(txt){
    var t=document.getElementById('toast');
    if(!t) return;
    t.textContent=txt;
    t.classList.add('show');
    clearTimeout(t._tid);
    t._tid=setTimeout(function(){ t.classList.remove('show'); },1700);
  }

  // ============ SHELL: works with or without GSAP ============
  function initShell(){
    // FAQ accordion
    document.querySelectorAll('.faq .item').forEach(function(item){
      var btn=item.querySelector('.qq');
      var ans=item.querySelector('.a');
      if(!btn||!ans) return;
      btn.addEventListener('click', function(){
        var open=item.classList.contains('open');
        document.querySelectorAll('.faq .item.open').forEach(function(o){
          o.classList.remove('open');
          var oa=o.querySelector('.a');
          if(oa) oa.style.maxHeight='0';
        });
        if(!open){ item.classList.add('open'); ans.style.maxHeight=ans.scrollHeight+'px'; }
      });
    });

    // search panel (demo)
    var searchTool=document.getElementById('searchTool');
    var searchPanel=document.getElementById('searchPanel');
    if(searchTool && searchPanel){
      searchTool.addEventListener('click', function(){
        searchPanel.classList.toggle('open');
        if(searchPanel.classList.contains('open')){
          var inp=document.getElementById('searchInput');
          if(inp) inp.focus();
        }
      });
    }
    var searchForm=document.getElementById('searchInput');
    if(searchForm){
      searchForm.addEventListener('keydown', function(e){
        if(e.key==='Enter'){ e.preventDefault(); toastMsg('// SEARCH'); }
      });
    }
    var acct=document.getElementById('acctTool');
    if(acct) acct.addEventListener('click', function(){ toastMsg('// ACCOUNT'); });
    var cartTool=document.getElementById('cartTool');
    if(cartTool) cartTool.addEventListener('click', function(){ toastMsg('// ACCESSING CART'); });

    // newsletter mock
    var form=document.getElementById('signupForm');
    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        toastMsg('// DEMO FORM · NOT WIRED');
      });
    }

    // filter chips
    var chips=Array.prototype.slice.call(document.querySelectorAll('.chip'));
    var cards=Array.prototype.slice.call(document.querySelectorAll('.product-card'));
    var countEl=document.getElementById('gridCount');
    chips.forEach(function(chip){
      chip.addEventListener('click', function(){
        chips.forEach(function(c){ c.classList.remove('on'); });
        chip.classList.add('on');
        var f=chip.getAttribute('data-filter');
        var shown=[];
        cards.forEach(function(card){
          var match = (f==='all') || (card.getAttribute('data-cat')===f);
          card.style.display = match ? '' : 'none';
          if(match) shown.push(card);
        });
        if(countEl) countEl.textContent=shown.length;
        if(hasGSAP && !reduce && shown.length){
          gsap.fromTo(shown,{opacity:0,y:26},{opacity:1,y:0,duration:.55,ease:'power3.out',stagger:.045,clearProps:'transform'});
        } else {
          shown.forEach(function(c){ c.style.opacity=1; });
        }
        if(hasST) ScrollTrigger.refresh();
      });
    });

    // anchors
    document.querySelectorAll('a[href^="#"]').forEach(function(a){
      a.addEventListener('click', function(e){
        var id=a.getAttribute('href');
        if(!id || id.length<2) return;
        var target=document.querySelector(id);
        if(!target) return;
        e.preventDefault();
        if(window.__molLenis){ window.__molLenis.scrollTo(target,{offset:-96,duration:1.2}); }
        else { target.scrollIntoView({behavior: reduce?'auto':'smooth'}); }
      });
    });
  }

  if(!hasGSAP){
    showAll(); killPreloader(); clearTimeout(safety); initShell();
    return;
  }

  if(hasST){ gsap.registerPlugin(ScrollTrigger); }

  // ================= LENIS =================
  var lenis=null;
  if(typeof window.Lenis !== 'undefined' && !reduce){
    lenis = new Lenis({ duration:1.1, easing:function(t){ return Math.min(1,1.001-Math.pow(2,-10*t)); }, smoothWheel:true });
    window.__molLenis = lenis;
    if(hasST){ lenis.on('scroll', ScrollTrigger.update); }
    gsap.ticker.add(function(t){ lenis.raf(t*1000); });
    gsap.ticker.lagSmoothing(0);
  }

  initShell();

  // ================= CURSOR =================
  var cursor=document.getElementById('cursor');
  if(cursor && !isTouch && !reduce){
    var cx=window.innerWidth/2, cy=window.innerHeight/2, tx=cx, ty=cy;
    window.addEventListener('mousemove', function(e){ tx=e.clientX; ty=e.clientY; });
    gsap.ticker.add(function(){
      cx += (tx-cx)*0.22; cy += (ty-cy)*0.22;
      cursor.style.transform='translate('+cx+'px,'+cy+'px) translate(-50%,-50%)';
    });
    document.querySelectorAll('[data-hot],a,button,input').forEach(function(el){
      el.addEventListener('mouseenter', function(){ cursor.classList.add('hot'); });
      el.addEventListener('mouseleave', function(){ cursor.classList.remove('hot'); });
    });
  } else if(cursor){ cursor.style.display='none'; }

  // ================= MAGNETIC =================
  if(!isTouch && !reduce){
    document.querySelectorAll('[data-magnetic]').forEach(function(el){
      el.addEventListener('mousemove', function(e){
        var r=el.getBoundingClientRect();
        var mx=e.clientX-(r.left+r.width/2);
        var my=e.clientY-(r.top+r.height/2);
        gsap.to(el,{x:mx*0.26,y:my*0.34,duration:.4,ease:'power3.out'});
      });
      el.addEventListener('mouseleave', function(){
        gsap.to(el,{x:0,y:0,duration:.6,ease:'elastic.out(1,.4)'});
      });
    });
  }

  // ================= NAV + PROGRESS =================
  var head=document.getElementById('head');
  var progress=document.getElementById('progress');
  var scrollPct=document.getElementById('scrollPct');
  function onScroll(){
    var st=window.pageYOffset || document.documentElement.scrollTop;
    var h=document.documentElement.scrollHeight - window.innerHeight;
    var p = h>0 ? st/h : 0;
    if(progress) progress.style.transform='scaleX('+p+')';
    if(scrollPct) scrollPct.textContent=(p*100<10?'0':'')+Math.round(p*100)+'%';
    if(head){ if(st>70) head.classList.add('shrunk'); else head.classList.remove('shrunk'); }
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();

  // ================= SPLIT HELPERS =================
  function splitChars(el){
    if(el.dataset.split==='1') return Array.prototype.slice.call(el.querySelectorAll('.ch'));
    var spans=[];
    function walk(node){
      var kids=Array.prototype.slice.call(node.childNodes);
      kids.forEach(function(child){
        if(child.nodeType===3){
          var text=child.textContent;
          var frag=document.createDocumentFragment();
          for(var i=0;i<text.length;i++){
            var s=document.createElement('span');
            s.className='ch';
            s.textContent = text[i]===' ' ? ' ' : text[i];
            frag.appendChild(s);
            spans.push(s);
          }
          node.replaceChild(frag,child);
        } else if(child.nodeType===1){
          walk(child);
        }
      });
    }
    walk(el);
    el.dataset.split='1';
    return spans;
  }
  function splitWords(el){
    if(el.dataset.wsplit==='1') return Array.prototype.slice.call(el.querySelectorAll('.w'));
    var words=el.textContent.split(/\s+/).filter(function(w){ return w.length; });
    el.textContent='';
    var out=[];
    words.forEach(function(word,i){
      var mask=document.createElement('span'); mask.className='wln';
      var inner=document.createElement('span'); inner.className='w';
      inner.textContent=word;
      mask.appendChild(inner);
      el.appendChild(mask);
      if(i<words.length-1) el.appendChild(document.createTextNode(' '));
      out.push(inner);
    });
    el.dataset.wsplit='1';
    return out;
  }

  // ================= HEADLINE TREATMENTS =================
  function animScatter(el){
    var chars=splitChars(el);
    chars.forEach(function(c){ c._x=rand(-300,300); c._y=rand(-200,200); c._r=rand(-95,95); });
    gsap.set(chars,{opacity:0});
    ScrollTrigger.create({trigger:el,start:'top 84%',once:true,onEnter:function(){
      gsap.fromTo(chars,
        {x:function(i,t){return t._x;},y:function(i,t){return t._y;},rotation:function(i,t){return t._r;},opacity:0},
        {x:0,y:0,rotation:0,opacity:1,duration:1.05,ease:'power4.out',stagger:{amount:.45,from:'random'}});
    }});
  }
  function animRise(el){
    el.style.overflow='hidden';
    var chars=splitChars(el);
    gsap.set(chars,{yPercent:115,opacity:0});
    ScrollTrigger.create({trigger:el,start:'top 86%',once:true,onEnter:function(){
      gsap.to(chars,{yPercent:0,opacity:1,duration:.9,ease:'power4.out',stagger:.028});
    }});
  }
  function animSkew(el){
    var chars=splitChars(el);
    gsap.set(chars,{opacity:0,skewX:36,x:32});
    ScrollTrigger.create({trigger:el,start:'top 86%',once:true,onEnter:function(){
      gsap.to(chars,{opacity:1,skewX:0,x:0,duration:.8,ease:'power3.out',stagger:.024});
    }});
  }
  function animSlam(el){
    var words=splitWords(el);
    gsap.set(words,{yPercent:118,rotation:5,transformOrigin:'0% 100%'});
    ScrollTrigger.create({trigger:el,start:'top 86%',once:true,onEnter:function(){
      gsap.to(words,{yPercent:0,rotation:0,duration:.95,ease:'expo.out',stagger:.07});
    }});
  }
  if(hasST && !reduce){
    document.querySelectorAll('[data-anim]').forEach(function(el){
      var t=el.getAttribute('data-anim');
      if(t==='scatter') animScatter(el);
      else if(t==='rise') animRise(el);
      else if(t==='skew') animSkew(el);
      else if(t==='slam') animSlam(el);
    });
  }

  // ================= SWEEP MOTIF =================
  function sweepReveal(el){
    el.classList.add('has-sweep');
    var cov=document.createElement('div');
    cov.className='sweepcover';
    cov.setAttribute('aria-hidden','true');
    el.appendChild(cov);
    gsap.set(cov,{scaleX:0,transformOrigin:'left center'});
    ScrollTrigger.create({trigger:el,start:'top 88%',once:true,onEnter:function(){
      gsap.timeline()
        .to(cov,{scaleX:1,duration:.32,ease:'power3.in'})
        .set(cov,{transformOrigin:'right center'})
        .to(cov,{scaleX:0,duration:.5,ease:'power3.out'});
    }});
  }

  // ================= SCROLL CHOREOGRAPHY =================
  if(hasST && !reduce){
    gsap.utils.toArray('.reveal:not(.product-card)').forEach(function(el){
      gsap.fromTo(el,{opacity:0,y:32},{opacity:1,y:0,duration:.85,ease:'power3.out',clearProps:'transform',
        scrollTrigger:{trigger:el,start:'top 90%',once:true}});
    });

    document.querySelectorAll('.sec-head').forEach(function(sh){
      var bar=document.createElement('span');
      bar.className='sec-rule';
      bar.setAttribute('aria-hidden','true');
      sh.appendChild(bar);
      gsap.fromTo(bar,{scaleX:0},{scaleX:1,ease:'none',
        scrollTrigger:{trigger:sh,start:'top 90%',end:'top 44%',scrub:.5}});
    });
    gsap.utils.toArray('.idx b').forEach(function(b){
      gsap.fromTo(b,{yPercent:70,opacity:0},{yPercent:0,opacity:1,duration:.7,ease:'power4.out',
        scrollTrigger:{trigger:b,start:'top 92%',once:true}});
    });

    // selling points
    gsap.utils.toArray('[data-pt]').forEach(function(pt,i){
      var ico=pt.querySelector('.ico');
      gsap.fromTo(pt,{opacity:0,y:40},{opacity:1,y:0,duration:.8,ease:'power3.out',delay:i*0.09,
        scrollTrigger:{trigger:'.points',start:'top 86%',once:true}});
      if(ico){
        gsap.fromTo(ico,{scale:.5,rotation:-22,opacity:0},{scale:1,rotation:0,opacity:1,duration:.8,ease:'back.out(2)',delay:0.16+i*0.09,
          scrollTrigger:{trigger:'.points',start:'top 86%',once:true}});
      }
    });

    // product cards
    var cardEls=gsap.utils.toArray('.product-card');
    if(cardEls.length){
      gsap.set(cardEls,{y:44});
      ScrollTrigger.batch(cardEls,{
        start:'top 92%',
        onEnter:function(batch){
          gsap.to(batch,{opacity:1,y:0,duration:.8,ease:'power3.out',stagger:.075,clearProps:'transform'});
          batch.forEach(function(card,i){
            var badge=card.querySelector('.pc-badge');
            var price=card.querySelector('.pc-price');
            if(badge){
              gsap.fromTo(badge,{scale:0,transformOrigin:'0% 0%'},{scale:1,duration:.5,ease:'back.out(2.4)',delay:.35+i*.075});
            }
            if(price){
              gsap.fromTo(price,{yPercent:70,opacity:0},{yPercent:0,opacity:1,duration:.55,ease:'power3.out',delay:.3+i*.075});
            }
          });
        }
      });
    }

    // story ledger
    var lp=document.getElementById('ledgerPath');
    if(lp){
      var len=lp.getTotalLength();
      lp.style.strokeDasharray=len+' '+len;
      lp.style.strokeDashoffset=len;
      var ldot=document.getElementById('ledgerDot');
      var prox={p:0};
      gsap.to(prox,{p:1,ease:'none',
        scrollTrigger:{trigger:'#story',start:'top 62%',end:'bottom 82%',scrub:.6},
        onUpdate:function(){
          lp.style.strokeDashoffset=String(len*(1-prox.p));
          if(ldot){
            var pt=lp.getPointAtLength(len*prox.p);
            ldot.setAttribute('cx',pt.x);
            ldot.setAttribute('cy',pt.y);
          }
        }});
    }
    gsap.utils.toArray('[data-lrow]').forEach(function(row,i){
      var val=row.querySelector('b');
      if(!val) return;
      var ch=splitChars(val);
      gsap.set(ch,{opacity:0});
      ScrollTrigger.create({trigger:row,start:'top 92%',once:true,onEnter:function(){
        gsap.to(ch,{opacity:1,duration:.22,ease:'power1.out',stagger:.02,delay:i*0.05});
      }});
    });
    var stamp=document.getElementById('ledgerStamp');
    if(stamp){
      gsap.set(stamp,{scale:2.2,opacity:0,rotation:-24});
      ScrollTrigger.create({trigger:'.ledger',start:'top 68%',once:true,onEnter:function(){
        gsap.to(stamp,{scale:1,opacity:1,rotation:-9,duration:.5,ease:'power4.in',delay:.5,onComplete:function(){
          gsap.fromTo('.ledger',{x:0},{x:4,duration:.08,yoyo:true,repeat:3,ease:'none'});
        }});
      }});
    }

    // reviews
    gsap.utils.toArray('.rev').forEach(function(rev,i){
      gsap.fromTo(rev,{opacity:0,y:40},{opacity:1,y:0,duration:.8,ease:'power3.out',delay:i*.09,
        scrollTrigger:{trigger:'.rev-grid',start:'top 86%',once:true}});
      var st=rev.querySelectorAll('.stars i');
      if(st.length){
        gsap.set(st,{scale:0,transformOrigin:'50% 50%'});
        ScrollTrigger.create({trigger:rev,start:'top 88%',once:true,onEnter:function(){
          gsap.to(st,{scale:1,duration:.4,ease:'back.out(3)',stagger:.06,delay:.2+i*.09});
        }});
      }
    });
    gsap.utils.toArray('.press span').forEach(function(sp,i){
      gsap.fromTo(sp,{opacity:0,y:16},{opacity:.34,y:0,duration:.6,ease:'power3.out',delay:i*.06,
        scrollTrigger:{trigger:'.press',start:'top 92%',once:true}});
    });

    // mosaic tiles
    gsap.utils.toArray('[data-tile]').forEach(function(tile,i){
      var tn=tile.querySelector('.tn');
      if(tn){
        gsap.fromTo(tn,{yPercent:80,opacity:0},{yPercent:0,opacity:1,duration:.75,ease:'power4.out',delay:.12+i*.06,
          scrollTrigger:{trigger:tile,start:'top 90%',once:true}});
      }
      sweepReveal(tile);
    });

    // datasheet rows
    var rows=gsap.utils.toArray('.spectable tbody tr');
    if(rows.length){
      gsap.set(rows,{opacity:0,x:-22});
      ScrollTrigger.create({trigger:'.tablewrap',start:'top 84%',once:true,onEnter:function(){
        gsap.to(rows,{opacity:1,x:0,duration:.6,ease:'power3.out',stagger:.045});
      }});
    }

    // faq
    var faqItems=gsap.utils.toArray('.faq .item');
    if(faqItems.length){
      gsap.set(faqItems,{opacity:0,y:24});
      ScrollTrigger.create({trigger:'.faq',start:'top 86%',once:true,onEnter:function(){
        gsap.to(faqItems,{opacity:1,y:0,duration:.7,ease:'power3.out',stagger:.06});
      }});
    }

    // counters
    document.querySelectorAll('[data-count]').forEach(function(el){
      var end=parseFloat(el.getAttribute('data-count'));
      var dec=parseInt(el.getAttribute('data-decimals')||'0',10);
      var pre=el.getAttribute('data-prefix')||'';
      var suf=el.getAttribute('data-suffix')||'';
      if(isNaN(end)) return;
      ScrollTrigger.create({trigger:el,start:'top 94%',once:true,onEnter:function(){
        var o={v:0};
        gsap.to(o,{v:end,duration:1.7,ease:'power2.out',onUpdate:function(){
          el.textContent=pre+o.v.toFixed(dec)+suf;
        }});
      }});
    });

    // sweeps on structural blocks
    document.querySelectorAll('.tablewrap, .ledger, .foot-disclaimer, .signup').forEach(sweepReveal);

    // ambient ghosts
    [
      {sel:'.hero', items:['C₁₄H₂₂CuN₆O₄','402.0 g/mol','LOT MOL-GHK-2611','≥99.1% AREA','HPLC-UV 214 nm']},
      {sel:'.cta',  items:['C₁₀H₁₀N₂','158.20 g/mol','IN STOCK']}
    ].forEach(function(set){
      var host=document.querySelector(set.sel);
      if(!host) return;
      set.items.forEach(function(txt,i){
        var g=document.createElement('span');
        g.className='ghost';
        g.setAttribute('aria-hidden','true');
        g.textContent=txt;
        g.style.left=(8+Math.random()*68)+'%';
        g.style.top=(12+Math.random()*66)+'%';
        g.style.fontSize=(11+Math.random()*6)+'px';
        host.appendChild(g);
        gsap.to(g,{opacity:.08,duration:1.6,delay:.7+i*.28,ease:'power1.out'});
        gsap.to(g,{x:rand(-32,32),y:rand(-24,24),rotation:rand(-3,3),duration:rand(9,15),ease:'sine.inOut',yoyo:true,repeat:-1});
      });
    });

    // drifting grids
    [['.hero','.hero .gridlines'],['#alerts','.cta .gridlines']].forEach(function(pair){
      var host=document.querySelector(pair[0]);
      var gl=document.querySelector(pair[1]);
      if(!host||!gl) return;
      gl.style.inset='-70px';
      gl.style.backgroundSize='64px 64px';
      var drift=gsap.to(gl,{x:64,y:64,duration:18,ease:'none',repeat:-1,paused:true});
      ScrollTrigger.create({trigger:host,start:'top bottom',end:'bottom top',
        onToggle:function(self){ if(self.isActive) drift.play(); else drift.pause(); }});
    });

    // footer
    gsap.fromTo('.foot-mega',{yPercent:34,opacity:0},{yPercent:0,opacity:1,duration:1,ease:'power4.out',
      scrollTrigger:{trigger:'footer',start:'top 90%',once:true}});
    gsap.fromTo('.foot-col',{y:28,opacity:0},{y:0,opacity:1,duration:.7,ease:'power3.out',stagger:.08,
      scrollTrigger:{trigger:'.foot-top',start:'top 92%',once:true}});

    // hero parallax on exit
    gsap.to('.hero-inner',{yPercent:-9,opacity:.35,ease:'none',
      scrollTrigger:{trigger:'.hero',start:'bottom 92%',end:'bottom top',scrub:.6}});
  } else {
    showAll();
    var pcs=document.querySelectorAll('.product-card');
    Array.prototype.forEach.call(pcs,function(c){ c.style.opacity=1; });
  }

  // ================= ANNOUNCEMENT ROTATOR =================
  (function(){
    var rot=document.getElementById('annRot');
    if(!rot) return;
    var slides=Array.prototype.slice.call(rot.querySelectorAll('.ann-slide'));
    if(!slides.length) return;
    if(reduce || !hasGSAP){
      slides.forEach(function(s,i){ s.style.opacity = i===0?'1':'0'; });
      return;
    }
    gsap.set(slides,{yPercent:120,opacity:0});
    gsap.set(slides[0],{yPercent:0,opacity:1});
    var idx=0;
    setInterval(function(){
      var cur=slides[idx];
      idx=(idx+1)%slides.length;
      var nxt=slides[idx];
      gsap.to(cur,{yPercent:-120,opacity:0,duration:.5,ease:'power3.inOut'});
      gsap.fromTo(nxt,{yPercent:120,opacity:0},{yPercent:0,opacity:1,duration:.5,ease:'power3.inOut'});
    },4200);
  })();

  // ================= HERO LATTICE CANVAS =================
  (function(){
    var cv=document.getElementById('latticeCanvas');
    if(!cv) return;
    var ctx=cv.getContext('2d');
    if(!ctx) return;
    var DPR=Math.min(window.devicePixelRatio||1,2);
    var W=0,H=0,nodes=[],raf=null,running=false;
    var cell=0,linkD=0,blade=0,bladeSpeed=0,verified=0,bonds=0,frame=0,t0=0;
    var LABELS=['C','H','N','O','C','N','H','O','C','H'];
    var pointer={x:-99999,y:-99999,on:false};

    var roNodes=document.getElementById('roNodes');
    var roBonds=document.getElementById('roBonds');
    var roScan=document.getElementById('roScan');
    var roVerified=document.getElementById('roVerified');

    function size(){
      var r=cv.getBoundingClientRect();
      cv.width=Math.max(1,Math.round(r.width*DPR));
      cv.height=Math.max(1,Math.round(r.height*DPR));
      W=cv.width; H=cv.height;
    }
    function build(){
      nodes=[];
      cell=Math.max(96*DPR, Math.min(200*DPR, W/6.4));
      linkD=cell*1.28;
      var cols=Math.max(3,Math.floor(W/cell));
      var rows=Math.max(2,Math.floor(H/cell));
      var offx=(W-(cols-1)*cell)/2;
      var offy=(H-(rows-1)*cell)/2;
      var i=0;
      for(var r=0;r<rows;r++){
        for(var c=0;c<cols;c++){
          nodes.push({
            tx:offx+c*cell+rand(-cell*.14,cell*.14),
            ty:offy+r*cell+rand(-cell*.14,cell*.14),
            x:rand(0,W), y:rand(0,H),
            ph:rand(0,Math.PI*2),
            r:rand(4.2,6.4)*DPR,
            label:LABELS[i%LABELS.length],
            cu:false, lit:0, seen:false
          });
          i++;
        }
      }
      if(nodes.length){
        var mid=Math.floor(nodes.length/2);
        nodes[mid].cu=true; nodes[mid].label='Cu'; nodes[mid].r=8.4*DPR;
      }
      blade=0; verified=0; bonds=0;
      bladeSpeed=W/300;
      if(reduce){
        nodes.forEach(function(n){ n.x=n.tx; n.y=n.ty; n.seen=true; });
        verified=nodes.length;
        blade=W;
      }
    }
    function step(ts){
      var time=ts-t0;
      var i,n;
      for(i=0;i<nodes.length;i++){
        n=nodes[i];
        var wx=n.tx+Math.sin(time*0.00042+n.ph)*cell*0.09;
        var wy=n.ty+Math.cos(time*0.00037+n.ph)*cell*0.09;
        if(pointer.on){
          var pdx=n.x-pointer.x, pdy=n.y-pointer.y;
          var pd=Math.sqrt(pdx*pdx+pdy*pdy);
          var R=150*DPR;
          if(pd<R && pd>0.01){
            var push=(1-pd/R)*46*DPR;
            wx+=pdx/pd*push; wy+=pdy/pd*push;
          }
        }
        n.x += (wx-n.x)*0.055;
        n.y += (wy-n.y)*0.055;
        if(n.lit>0) n.lit-=0.018;
      }
      blade+=bladeSpeed;
      if(blade>W+cell){ blade=-cell; verified=0; for(i=0;i<nodes.length;i++){ nodes[i].seen=false; } }
      for(i=0;i<nodes.length;i++){
        n=nodes[i];
        if(!n.seen && n.x<=blade){ n.seen=true; n.lit=1; verified++; }
      }
    }
    function draw(){
      ctx.clearRect(0,0,W,H);
      var i,j,a,b;
      bonds=0;
      for(i=0;i<nodes.length;i++){
        for(j=i+1;j<nodes.length;j++){
          a=nodes[i]; b=nodes[j];
          var dx=a.x-b.x, dy=a.y-b.y;
          var d=Math.sqrt(dx*dx+dy*dy);
          if(d<linkD){
            bonds++;
            var o=(1-d/linkD);
            ctx.strokeStyle='rgba(10,10,10,'+(o*0.42)+')';
            ctx.lineWidth=((a.cu||b.cu)?2:1)*DPR;
            ctx.beginPath(); ctx.moveTo(a.x,a.y); ctx.lineTo(b.x,b.y); ctx.stroke();
          }
        }
      }
      // scan blade
      if(blade>=0 && blade<=W){
        ctx.fillStyle='rgba(255,229,0,.85)';
        ctx.fillRect(blade-1.5*DPR,0,3*DPR,H);
        ctx.fillStyle='rgba(255,229,0,.12)';
        ctx.fillRect(blade-46*DPR,0,46*DPR,H);
      }
      for(i=0;i<nodes.length;i++){
        var n=nodes[i];
        var s=n.r*2;
        var lit=n.lit>0?n.lit:0;
        if(n.cu){
          var g=(6+lit*10)*DPR;
          ctx.fillStyle='#ffe500';
          ctx.fillRect(n.x-n.r-g/2,n.y-n.r-g/2,s+g,s+g);
          ctx.fillStyle='#0a0a0a';
          ctx.fillRect(n.x-n.r,n.y-n.r,s,s);
          ctx.fillStyle='#ffe500';
        } else if(lit>0.02){
          var e=lit*5*DPR;
          ctx.fillStyle='#ffe500';
          ctx.fillRect(n.x-n.r-e,n.y-n.r-e,s+e*2,s+e*2);
          ctx.fillStyle='#0a0a0a';
          ctx.fillRect(n.x-n.r,n.y-n.r,s,s);
          ctx.fillStyle='#ffe500';
        } else {
          ctx.fillStyle='#0a0a0a';
          ctx.fillRect(n.x-n.r,n.y-n.r,s,s);
          ctx.fillStyle='#ffffff';
        }
        ctx.font='700 '+((n.cu?11:9)*DPR)+'px "Space Mono",monospace';
        ctx.textAlign='center'; ctx.textBaseline='middle';
        ctx.fillText(n.label,n.x,n.y+0.5*DPR);
      }
      // pointer reticle
      if(pointer.on){
        ctx.strokeStyle='rgba(10,10,10,.5)';
        ctx.lineWidth=1*DPR;
        ctx.beginPath();
        ctx.moveTo(pointer.x-26*DPR,pointer.y); ctx.lineTo(pointer.x+26*DPR,pointer.y);
        ctx.moveTo(pointer.x,pointer.y-26*DPR); ctx.lineTo(pointer.x,pointer.y+26*DPR);
        ctx.stroke();
      }
    }
    function readouts(){
      if(roNodes) roNodes.textContent=String(nodes.length);
      if(roBonds) roBonds.textContent=String(bonds);
      if(roScan) roScan.textContent=Math.max(0,Math.min(100,Math.round(blade/Math.max(1,W)*100)))+'%';
      if(roVerified) roVerified.textContent=String(verified);
    }
    function loop(ts){
      if(!t0) t0=ts;
      step(ts);
      draw();
      frame++;
      if(frame%6===0) readouts();
      raf=requestAnimationFrame(loop);
    }
    function start(){
      if(running) return;
      running=true;
      if(reduce){ draw(); readouts(); return; }
      raf=requestAnimationFrame(loop);
    }
    function stop(){
      running=false;
      if(raf) cancelAnimationFrame(raf);
      raf=null;
    }
    size(); build(); draw(); readouts();
    if(!isTouch && !reduce){
      cv.parentNode.addEventListener('mousemove', function(e){
        var r=cv.getBoundingClientRect();
        pointer.x=(e.clientX-r.left)*DPR;
        pointer.y=(e.clientY-r.top)*DPR;
        pointer.on=true;
      });
      cv.parentNode.addEventListener('mouseleave', function(){ pointer.on=false; });
    }
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting) start(); else stop(); });
      },{threshold:0.02});
      io.observe(cv);
    } else { start(); }
    var rz;
    window.addEventListener('resize', function(){
      clearTimeout(rz);
      rz=setTimeout(function(){ size(); build(); draw(); readouts(); },200);
    });
    lattice={
      scatter:function(){
        if(reduce) return;
        nodes.forEach(function(n){ n.x=rand(0,W); n.y=rand(0,H); n.seen=false; n.lit=1; });
        blade=-cell; verified=0;
      }
    };
  })();

  // ================= STABLE HERO INTRO =================
  // The merchant hero uses normal text flow. Only the lattice canvas animates.
  // No SplitText or GSAP transforms are applied to hero copy or controls.
  function heroIntro(){
    var hero=document.querySelector('[data-mol-hero]');
    if(!hero) return;
    hero.querySelectorAll('*').forEach(function(el){
      if(el.style && (el.style.opacity==='0' || el.style.visibility==='hidden')){
        el.style.opacity='';
        el.style.visibility='';
        el.style.transform='';
      }
    });
    if(hasST) requestAnimationFrame(function(){ ScrollTrigger.refresh(); });
  }

  // ================= PRELOADER =================
  function runPreloader(){
    var countEl=document.getElementById('plCount');
    var barEl=document.getElementById('plBar');
    var pf=document.getElementById('plFormula');
    var plChars= pf ? splitChars(pf) : [];
    if(reduce){
      killPreloader(); clearTimeout(safety); heroIntro();
      if(hasST) ScrollTrigger.refresh();
      return;
    }
    var tl=gsap.timeline({onComplete:function(){
      killPreloader(); clearTimeout(safety); heroIntro();
      if(hasST) ScrollTrigger.refresh();
    }});
    if(plChars.length){
      gsap.set(plChars,{opacity:0,yPercent:26});
      tl.to(plChars,{opacity:1,yPercent:0,duration:.5,stagger:{amount:.5,from:'random'},ease:'power2.out'},0);
    }
    var c={v:0};
    tl.to(c,{v:100,duration:1.4,ease:'power2.inOut',onUpdate:function(){
      var val=Math.round(c.v);
      if(countEl) countEl.textContent=(val<10?'00':val<100?'0':'')+val;
      if(barEl) barEl.style.width=val+'%';
    }},0.1);
    tl.to('#preloader .pl-count',{scale:1.06,duration:.18,yoyo:true,repeat:1,ease:'power2.out'},'>-0.08');
  }
  runPreloader();

  // ================= EASTER EGG =================
  var buf='';
  window.addEventListener('keydown', function(e){
    var tag=(e.target && e.target.tagName)||'';
    if(tag==='INPUT'||tag==='TEXTAREA') return;
    if(e.key && e.key.length===1){
      buf=(buf+e.key.toLowerCase()).slice(-8);
      if(buf.indexOf('shop')!==-1){
        buf='';
        toastMsg('// LATTICE RESET');
        if(lattice && lattice.scatter) lattice.scatter();
        var f=document.getElementById('heroFormula');
        if(f && !reduce){
          var chars=splitChars(f);
          gsap.killTweensOf(chars);
          gsap.timeline()
            .to(chars,{y:function(){return rand(-160,160);},rotation:function(){return rand(-40,40);},opacity:.35,duration:.35,ease:'power3.out',stagger:{amount:.14,from:'center'}})
            .to(chars,{y:0,rotation:0,opacity:1,duration:.95,ease:'elastic.out(1,.55)',stagger:{amount:.26,from:'random'}},'+=0.04');
        }
      }
    }
  });

  document.addEventListener('shopify:section:load',function(event){
    if(!event.target || !event.target.querySelector('[data-mol-hero]')) return;
    requestAnimationFrame(function(){ heroIntro(); if(hasST) ScrollTrigger.refresh(); });
  });

  // ================= REFRESH HOOKS =================
  window.addEventListener('load', function(){ if(hasST) ScrollTrigger.refresh(); });
  if(document.fonts && document.fonts.ready && document.fonts.ready.then){
    document.fonts.ready.then(function(){ if(hasST) ScrollTrigger.refresh(); });
  }
})();


(function(){
function refresh(){if(window.ScrollTrigger)requestAnimationFrame(function(){ScrollTrigger.refresh();});}
document.addEventListener('shopify:section:load',refresh);document.addEventListener('shopify:section:reorder',refresh);
})();

/* Shopify Route B interface controls */
(function(){
  function lockBody(lock){ document.documentElement.style.overflow=lock?'hidden':''; document.body.style.overflow=lock?'hidden':''; }
  function initShell(root){
    root=root||document;
    var openBtn=document.querySelector('[data-mobile-toggle]');
    var drawer=document.querySelector('[data-mobile-drawer]');
    var backdrop=document.querySelector('[data-mobile-backdrop]');
    var closeBtn=document.querySelector('[data-mobile-close]');
    function closeDrawer(){ if(!drawer)return; drawer.classList.remove('is-open'); backdrop&&backdrop.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); openBtn&&openBtn.setAttribute('aria-expanded','false'); lockBody(false); }
    function openDrawer(){ if(!drawer)return; drawer.classList.add('is-open'); backdrop&&backdrop.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); openBtn&&openBtn.setAttribute('aria-expanded','true'); lockBody(true); closeBtn&&closeBtn.focus(); }
    if(openBtn&&!openBtn.dataset.ready){openBtn.dataset.ready='1';openBtn.addEventListener('click',openDrawer)}
    if(closeBtn&&!closeBtn.dataset.ready){closeBtn.dataset.ready='1';closeBtn.addEventListener('click',closeDrawer)}
    if(backdrop&&!backdrop.dataset.ready){backdrop.dataset.ready='1';backdrop.addEventListener('click',closeDrawer)}
    drawer&&drawer.querySelectorAll('a').forEach(function(a){if(!a.dataset.ready){a.dataset.ready='1';a.addEventListener('click',closeDrawer)}});

    var searchOpen=document.querySelector('[data-search-open]');
    var search=document.querySelector('[data-search-modal]');
    var searchClose=document.querySelector('[data-search-close]');
    function closeSearch(){if(!search)return;search.classList.remove('is-open');search.setAttribute('aria-hidden','true');lockBody(false);searchOpen&&searchOpen.focus()}
    function openSearch(){if(!search)return;search.classList.add('is-open');search.setAttribute('aria-hidden','false');lockBody(true);setTimeout(function(){search.querySelector('input')&&search.querySelector('input').focus()},50)}
    if(searchOpen&&!searchOpen.dataset.ready){searchOpen.dataset.ready='1';searchOpen.addEventListener('click',openSearch)}
    if(searchClose&&!searchClose.dataset.ready){searchClose.dataset.ready='1';searchClose.addEventListener('click',closeSearch)}
    if(search&&!search.dataset.ready){search.dataset.ready='1';search.addEventListener('click',function(e){if(e.target===search)closeSearch()})}
    document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeDrawer();closeSearch()}});

    document.querySelectorAll('[data-footer-marquee]').forEach(function(track){
      if(track.dataset.ready)return; track.dataset.ready='1';
      if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
      var speed=parseFloat(track.dataset.speed)||28;
      if(window.gsap){
        requestAnimationFrame(function(){var distance=track.scrollWidth/3;gsap.fromTo(track,{x:0},{x:-distance,duration:speed,ease:'none',repeat:-1});});
      } else { track.style.animation='marq '+speed+'s linear infinite'; }
    });
  }
  document.addEventListener('DOMContentLoaded',function(){initShell(document)});
  document.addEventListener('shopify:section:load',function(){initShell(document);if(window.ScrollTrigger)requestAnimationFrame(function(){ScrollTrigger.refresh()})});
})();

/* Route B v3 modal, age gate and drawer hardening */
(function(){
  function setPageLock(locked){
    document.documentElement.classList.toggle('modal-open',locked);
    document.body.classList.toggle('modal-open',locked);
  }
  function initRegressionFixes(root){
    root=root||document;
    var age=root.querySelector('[data-age-gate]')||document.querySelector('[data-age-gate]');
    if(age&&!age.dataset.ready){
      age.dataset.ready='1';
      var enter=age.querySelector('[data-age-enter]');
      if(enter) enter.addEventListener('click',function(){age.classList.remove('is-visible');age.remove();setPageLock(false);});
      requestAnimationFrame(function(){ if(document.body.contains(age)){age.classList.add('is-visible');setPageLock(true);enter&&enter.focus();} });
    }

    var drawer=document.querySelector('[data-mobile-drawer]');
    if(drawer){
      drawer.querySelectorAll('.mobile-drawer__nav a').forEach(function(link){link.removeAttribute('tabindex');});
    }
  }
  document.addEventListener('DOMContentLoaded',function(){initRegressionFixes(document)});
  document.addEventListener('shopify:section:load',function(e){initRegressionFixes(e.target)});
})();
/* Mobile-adaptive canvases v2: phones change layout boxes after first paint
   (font load, URL-bar collapse, aspect-ratio media flips) without always
   firing a window resize. Watch each canvas's own box and replay the theme's
   resize path ONLY when the box genuinely changed — several heroes rebuild
   and replay their intro on resize, so a synthetic ping on load or on the
   observer's first callback would visibly restart them. */
(function () {
  if (!('ResizeObserver' in window)) return;
  var last = new WeakMap();
  var t;
  function ping() { clearTimeout(t); t = setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 120); }
  var ro = new ResizeObserver(function (entries) {
    var changed = false;
    entries.forEach(function (en) {
      var r = en.target.getBoundingClientRect();
      var p = last.get(en.target);
      last.set(en.target, { w: r.width, h: r.height });
      if (p && (Math.abs(p.w - r.width) > 1 || Math.abs(p.h - r.height) > 1)) changed = true;
    });
    if (changed) ping();
  });
  function watch() { document.querySelectorAll('canvas').forEach(function (c) { ro.observe(c); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  window.addEventListener('orientationchange', function () { setTimeout(ping, 200); });
})();
